import { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setIsFirstView } from 'redux/actions'
import { Permission, Workspace } from 'types'
import { LazyComponentWrapper } from 'components/LazyComponentWrapper/LazyComponentWrapper'
import { lazyRetry } from 'utils/lazyRetry'
import { UserClient } from 'api/clients/UserClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import useIsMounted from 'ismounted'
import { useAuth } from 'hooks/UseAuth'

const GuestWelcomeModal = lazyRetry(() => import('../GuestWelcomeModal'))

export const useGuestWelcomeModal = (accessLevel?: Permission, workspace?: Workspace, inviterName?: string | null) => {
  const dispatch = useDispatch()
  const [initialArticleUrl, setInitialArticleUrl] = useState('/')
  const [show, setShow] = useState(false)
  const isMounted = useIsMounted()
  const auth = useAuth()

  useEffect(() => {
    const fetchInitialArticle = async () => {
      const response = await UserClient.getInitialArticle()
      if (response && response.type === SUCCESS_RESPONSE_TYPE) {
        const {
          data: { url },
        } = response
        if (isMounted.current && url) setInitialArticleUrl(url)
      }
    }
    if (auth) fetchInitialArticle()
  }, [isMounted, auth])

  useEffect(() => {
    const shouldShow = Boolean(workspace?.guest && (workspace?.is_new || workspace?.isFirstView))
    if (shouldShow && !show) setShow(true)
  }, [show, workspace])

  const close = useCallback(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dispatch(setIsFirstView({ isFirstView: false, key: workspace!.key }))
    setShow(false)
  }, [setShow, dispatch, workspace])

  const renderModal = () => {
    if (!workspace || !inviterName) return null

    return (
      <LazyComponentWrapper
        component={
          <GuestWelcomeModal
            workspace={workspace}
            show={show}
            close={close}
            access={accessLevel ?? Permission.Read}
            inviterName={inviterName}
            initialArticleUrl={initialArticleUrl}
          />
        }
      />
    )
  }

  return renderModal
}
